<template>
  <div>
    <div class="cover posa">
      <div class="iphone Rotate"></div>
      <p>为了更好的用户体验，请将屏幕竖向浏览！</p>
    </div>
    <div class="cs" style="display: flex; flex-direction: column" ref="cs">
      <!-- <NavBarM @jump="jump"></NavBarM> -->
      <div class="slide-vertical">
        <div class="vertical-wrapper">
          <div class="slide-vertical-wrapper" ref="slide">
            <div class="slide-vertical-content">
              <Welcome @jump="jump"></Welcome>
              <!-- 公司简介 -->
              <Page1 @jump="jump"></Page1>
              <Page2 @jump="jump"></Page2>
              <!-- <Page3 @jump="jump"></Page3> -->
              <Page4 @jump="jump" ref="page4"></Page4>
              <Page5 @jump="jump"></Page5>
              <Page6 @jump="jump"></Page6>
            </div>
          </div>
          <!-- <div class="dots-wrapper">
        <span
          class="dot"
          v-for="num in state.nums"
          :key="num"
          :class="{ active: currentPageIndex === num - 1 }"
        ></span>
      </div> -->
        </div>
      </div>
      <!-- <FooterM></FooterM> -->
    </div>
  </div>
</template>
<script>
import { isMobile } from "@/assets/js/index.js";
import BScroll from "@better-scroll/core";
import Slide from "@better-scroll/slide";
import NestedScroll from "@better-scroll/nested-scroll";
import Page1 from "./page1.vue";
import Page2 from "./page2.vue";
// import Page3 from "./page3.vue";
import Page4 from "./page4.vue";
import Page5 from "./page5.vue";
import Page6 from "./page6.vue";
import Welcome from "./welcome.vue";
// import NavBarM from "../../components/NavBarM.vue";
// import FooterM from "../../components/FooterM.vue";
BScroll.use(Slide);
BScroll.use(NestedScroll);
export default {
  name: "mobile",
  components: {
    // NavBarM,
    // FooterM,
    Welcome,
    Page1,
    Page2,
    // Page3,
    Page4,
    Page5,
    Page6,
  },
  data() {
    return {
      bScroll: null,
    };
  },
  methods: {
    jump(i) {
      if(i==3)i=2
      this.bScroll.goToPage(0, i);
    },
    init() {
      this.bScroll = new BScroll(this.$refs.slide, {
        scrollX: false,
        scrollY: true,
        slide: {
          threshold: 100,
          autoplay: false,
          loop: false,
        },
        observeDOM: true,
        nestedScroll: {
          groupId: "asdf",
        },
        useTransition: true,
        momentum: false,
        bounce: false,
        stopPropagation: true,
        click: true,
      });
      this.bScroll.on("slideWillChange", (page) => {
        //计算高度时机不对，需要切到页面时重新计算
        if (page.pageY == 4) {
          this.$refs.page4.refreshBS();
        }
      });
    },
  },
  mounted() {
    if (!isMobile()) {
      this.$router.replace({ name: "welcome" });
    }
    this.init();
  },
};
</script>
<style>
@import "../../assets/css/load.css";
.slide-content {
  height: calc(100vh - 1.8rem - env(safe-area-inset-bottom));
  /* -1.8rem */
  overflow: hidden;
}
.slide-vertical {
  /* height: 100%; */
  flex: 1;
}
.slide-vertical .vertical-wrapper {
  position: relative;
  height: 100%;
  font-size: 0;
}
.slide-vertical .slide-vertical-wrapper {
  /* height: 100vh; */
  height: calc(100vh - env(safe-area-inset-bottom));
  overflow: hidden;
}
.slide-vertical .slide-vertical-wrapper .slide-page {
  /* height: 100vh; */
  height: calc(100vh - 1.8rem - env(safe-area-inset-bottom));
  display: inline-block;
  width: 100%;
  /* line-height: 200px; */
  text-align: center;
  font-size: 26px;
  transform: translate3d(0, 0, 0);
  backface-visibility: hidden;
  overflow: hidden;
}
.slide-content > div:nth-child(1) {
  min-height: calc(100vh - 1.7rem - env(safe-area-inset-bottom));
}
p {
  font-size: 0.44rem;
  text-indent: 2em;
  margin-bottom: 0.2rem;
  text-align: left;
}
.text {
  font-size: 0.24rem;
  line-height: 0.4rem;
  text-align: justify;
}
.slide-page {
  background-image: url("../../assets/img/app/app-bg1.jpg");
  background-repeat: no-repeat;
  /* background-position: top/100% ; */
  background-size: cover;
  background-color: rgba(255, 255, 255, 0.8);
}
.slide-page:nth-child(1) {
  background-image: url("../../assets/img/app/app-start/app-bg.jpg");
}
.slide-page:nth-child(2) {
  background-image: unset;
}
.title-img {
  height: 1.5rem;
  width: auto;
}
</style>
